import React, { useState, useEffect } from "react";
import {formatJSON} from "../services/Common";


const CodeBox = ({ content, maxHeight = "150px", type = "default" }) => {
    const getBackgroundColor = () => {
        switch (type) {
            case 'url': return '#f8f9fa';
            case 'request': return '#fff8f8';
            case 'response': return '#f8fff8';
            default: return '#f5f5f5';
        }
    };

    const formattedContent = formatJSON(content);
    const isEmpty = !content && content !== 0;

    return (
        <div style={{
            background: getBackgroundColor(),
            border: '1px solid #ddd',
            borderRadius: '4px',
            padding: '8px',
            maxHeight: maxHeight,
            overflow: 'auto',
            position: 'relative'
        }}>
            {isEmpty ? (
                <span style={{ color: '#999', fontStyle: 'italic' }}>
                    No data
                </span>
            ) : (
                <pre style={{ 
                    margin: 0,
                    whiteSpace: 'pre-wrap',
                    fontSize: '12px',
                    fontFamily: 'Consolas, Monaco, monospace',
                    wordBreak: 'break-word'
                }}>
                    {formattedContent}
                </pre>
            )}
        </div>
    );
};

export default CodeBox;